import axios from "./axios";

const login = credentials => {
    return axios.post('/auth/login', credentials)
        .then(response => response.data)
}

const loginEmployee = credentials => {
    return axios.post('auth/employee/login', credentials)
        .then(response => response.data)
}

const fetchCurrentUser = () => {
    return axios.get('/user/profile')
        .then(response => response.data)
}

const getEKyzmatUrl = () => {
    return axios.get('/auth/employee/get-ekyzmat-url')
        .then((response) => response.data);
}

const checkEkyzmatLogin = credentials => {
    return axios.post('/auth/employee/e-kyzmat-check', credentials);
}

const sendLinkToEmail = credentials => {
    return axios.post('/auth/reset-password', credentials);
}

const resetPassword = (token, credentials) => {
    return axios.post(`/auth/reset-password/reset/${token}`, credentials);
}

export default {
    login,
    loginEmployee,
    fetchCurrentUser,
    getEKyzmatUrl,
    checkEkyzmatLogin,
    sendLinkToEmail,
    resetPassword,
}
